<template>
  <footer class="control-bar" aria-label="Playback controls">
    <button
      class="control-button"
      type="button"
      title="Add audio files"
      @click="$emit('add')"
    >
      <i class="fa fa-file-audio-o" aria-hidden="true"></i>
    </button>
    <button
      class="control-button"
      type="button"
      :disabled="disabled"
      title="Stop"
      @click="$emit('stop')"
    >
      <i class="fa fa-stop" aria-hidden="true"></i>
    </button>
    <button
      class="control-button primary"
      type="button"
      :disabled="disabled"
      title="Play or pause"
      @click="$emit('play-toggle')"
    >
      <i
        class="fa"
        :class="paused ? 'fa-play' : 'fa-pause'"
        aria-hidden="true"
      ></i>
    </button>
    <button
      class="control-button"
      type="button"
      :disabled="disabled"
      title="Previous"
      @click="$emit('previous')"
    >
      <i class="fa fa-step-backward" aria-hidden="true"></i>
    </button>
    <button
      class="control-button"
      type="button"
      :disabled="disabled"
      title="Next"
      @click="$emit('next')"
    >
      <i class="fa fa-step-forward" aria-hidden="true"></i>
    </button>
    <button
      class="control-button"
      :class="{ active: random }"
      type="button"
      title="Random"
      @click="$emit('random')"
    >
      <i class="fa fa-random" aria-hidden="true"></i>
    </button>
    <button
      class="control-button"
      :class="{ active: loop }"
      type="button"
      title="Loop"
      @click="$emit('loop')"
    >
      <i class="fa fa-rotate-right" aria-hidden="true"></i>
    </button>
    <button
      class="control-button"
      type="button"
      title="Volume"
      @click="$emit('volume')"
    >
      <i class="fa" :class="volumeIcon" aria-hidden="true"></i>
    </button>
    <button
      class="control-button danger"
      type="button"
      title="Clear library"
      @click="$emit('clear')"
    >
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
  </footer>
</template>

<script setup>
/* global defineProps, defineEmits */
import { computed } from "vue";

const props = defineProps({
  disabled: {
    type: Boolean,
    default: true,
  },
  paused: {
    type: Boolean,
    default: true,
  },
  random: {
    type: Boolean,
    default: false,
  },
  loop: {
    type: Boolean,
    default: false,
  },
  volume: {
    type: Number,
    default: 1,
  },
});

defineEmits([
  "add",
  "stop",
  "previous",
  "play-toggle",
  "next",
  "random",
  "loop",
  "volume",
  "clear",
]);

const volumeIcon = computed(() => {
  if (props.volume === 0) return "fa-volume-off";
  if (props.volume <= 0.5) return "fa-volume-down";
  return "fa-volume-up";
});
</script>

<style scoped lang="less">
.control-bar {
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  justify-content: center;
  margin-top: 22px;
}

.control-button {
  display: inline-flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  color: #ded7d3;
  background: rgba(255, 255, 255, 0.045);
  cursor: pointer;
}

.control-button:hover,
.control-button:focus-visible,
.control-button.active {
  border-color: rgba(255, 255, 255, 0.28);
  color: #ffffff;
  background: rgba(195, 41, 54, 0.3);
  outline: none;
}

.control-button.primary {
  color: #ffffff;
  background: #c32936;
}

.control-button.danger:hover,
.control-button.danger:focus-visible {
  background: rgba(241, 93, 75, 0.34);
}

.control-button[disabled] {
  cursor: not-allowed;
  opacity: 0.38;
}
</style>
